export const LOGIN = "LOGIN";
export const UPDATE_LOGGED_DATA = "UPDATE_LOGGED_DATA";
export const LOGOUT = "LOGOUT";